import React, { Suspense } from 'react'
import LayoutSkeleton from 'common/Skeletons/LayoutSkeleton'

import ExternalUserSearch from './components/ExternalUserSearch'

export default function ExternalUsersDashboard() {
  return (
    <>
      <Suspense fallback={<LayoutSkeleton />}>
        <ExternalUserSearch />
      </Suspense>
    </>
  )
}
